require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEmptyString = exports.createStyleSheet = exports.createScriptTag = exports.getPadding = void 0;

var getPadding = function getPadding(aspectRatio) {
  var config = {
    '1:1': {
      paddingTop: '100%'
    },
    '16:9': {
      paddingTop: '56.25%'
    },
    '4:3': {
      paddingTop: '75%'
    },
    '3:2': {
      paddingTop: '66.66%'
    },
    '8.5': {
      paddingTop: '62.5%'
    }
  }; // @ts-ignore

  return config[aspectRatio];
};

exports.getPadding = getPadding;

var createScriptTag = function createScriptTag(providerEmbedUrl, providerEmbedScript) {
  var script = document.createElement("script");
  script.type = "text/javascript";

  if (providerEmbedUrl) {
    script.src = providerEmbedUrl;
  }

  if (providerEmbedScript) {
    script.innerText = providerEmbedScript;
  }

  script.onerror = function (error) {
    console.error("MDXEmbedProvider ".concat(error.type), error);
  };

  document.getElementsByTagName("head")[0].appendChild(script);
};

exports.createScriptTag = createScriptTag;

var createStyleSheet = function createStyleSheet(href) {
  var link = document.createElement("link");
  link.type = "text/css";
  link.rel = "stylesheet";
  link.href = href;
  document.getElementsByTagName("head")[0].appendChild(link);
};

exports.createStyleSheet = createStyleSheet;

var isEmptyString = function isEmptyString(value) {
  return value === null || value === undefined || value.length === 0;
};

exports.isEmptyString = isEmptyString;